import React, { useState } from "react";
import { Pagination } from "react-bootstrap";

function PaginationPage(props) {
  var [active, setActive] = useState(1);

  const paginationOnclick = (e, page) => {
    e.preventDefault();
    setActive(page);
    props.changeCurrentpage(page);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Pagination>
      {props?.links?.map((item, index) =>
        <React.Fragment key={index.toString()}>
          {item.label === null ? (
            <></>
          ) : item.label === "&laquo; Öncesi" ||
            item.label === "&laquo; Previous" ? (
            <Pagination.Prev
              onClick={(e) => {
                paginationOnclick(e, active - 1);
              }}
            />
          ) : item.label === "Sonraki &raquo;" ||
            item.label === "Next &raquo;" ? (
            <Pagination.Next
              onClick={(e) => {
                paginationOnclick(e, active + 1);
              }}
            />
          ) : item.label === "..." ? (
            <Pagination.Ellipsis />
          ) : (
            <Pagination.Item
              active={item.active}
              onClick={(e) => {
                paginationOnclick(e, Number(item?.label));
              }}
            >
              {Number(item?.label)}
            </Pagination.Item>
          )}
        </React.Fragment>
      )}
    </Pagination>
  );
}
export default PaginationPage;
